import { notificationsStaleChecked, selectHasRunningJobs } from './notificationsSlice';

const CHECK_EVERY_MS = 30 * 1000;

/**
 * Marks the Activity Center's jobs that went quiet, so a job whose worker died
 * stops reading as "running" forever.
 *
 * One timer for every running job, alive only while something runs.
 *
 * @param {Function} startListening - From the store's listener middleware.
 */
export const registerNotificationsListeners = (startListening) => {
  // A flag rather than unsubscribing while the loop runs: the toast another
  // listener dispatches for the same action reaches this predicate first, and
  // the outer pass would still run it from its own copy of the listeners —
  // two loops for one job.
  let watching = false;

  startListening({
    predicate: (action, state) => !watching && selectHasRunningJobs(state),
    effect: async (action, { getState, dispatch, delay }) => {
      watching = true;
      try {
        while (selectHasRunningJobs(getState())) {
          await delay(CHECK_EVERY_MS);
          dispatch(notificationsStaleChecked(Date.now()));
        }
      } finally {
        watching = false;
      }
    },
  });
};
